module.exports = __webpack_public_path__ + "static/media/1021410.16ef8848.jpg";